import { useParams } from 'react-router-dom';
import { useNavigate } from './useNavigate';

/**
 * Abre o destino de um menu/item de menu: URL externa em nova aba, âncora da home direto no navegador
 * e rota interna (ex.: o slug de página customizada) como caminho absoluto, preservando o prefixo /:state/:city.
 * newTab também abre rotas internas em nova aba (opção "Abrir em nova aba" da home customizada).
 */
export const useMenuLinkNavigation = () => {
  const navigate = useNavigate();
  const { state, city } = useParams<{ state?: string; city?: string }>();

  return (url?: string, newTab?: boolean) => {
    if (!url) return;

    const isAbsolute = /^https?:\/\//i.test(url);
    // Link externo cadastrado sem protocolo (ex.: "www.site.com.br"); slugs e rotas do portal nunca têm ponto
    const isBareDomain = !isAbsolute && /^[\w-]+(\.[\w-]+)+(\/|$)/i.test(url);

    if (isBareDomain) {
      window.open(`https://${url}`, '_blank', 'noopener,noreferrer');
    } else if (isAbsolute || (newTab && url.startsWith('/#'))) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else if (url.startsWith('/#')) {
      window.location.href = url;
    } else if (newTab) {
      const path = url.replace(/^\//, '');
      window.open(state && city ? `/${state}/${city}/${path}` : `/${path}`, '_blank', 'noopener,noreferrer');
    } else {
      navigate(url.startsWith('/') ? url : `/${url}`);
    }
  };
};
